'use client';

import moment from 'moment/moment';
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { updateApplication } from '../../../../redux/features/adminLeadSlice';
import { LuCalendar1 } from 'react-icons/lu';
import { Country, City, State } from 'country-state-city';
import { CustomSelect } from '../../../common/CustomSelect';
function getCitiesByCountry(countryName) {
  const country = Country.getAllCountries().find(
    (c) => c.name.toLowerCase() === countryName.toLowerCase(),
  );

  if (!country) return [];

  const states = State.getStatesOfCountry(country.isoCode);

  let cities = [];

  states.forEach((state) => {
    const stateCities = City.getCitiesOfState(country.isoCode, state.isoCode);
    cities = [...cities, ...stateCities];
  });

  return cities.map((c) => c.name);
}
export default function AgentApplicationForm({ selectedData }) {
  const FIELD_LIMITS = {
    firstName: 100,
    lastName: 100,
    passportNumber: 20,
    children: 2,
    address: 120,
    city: 60,
    country: 60,
    zipcode: 12,
    mobileNumber: 15,
    email: 100,
    secondaryEmail: 100,
    qualifications: 80,
    yearOfCompletion: 4,
    jobTitle: 60,
    countryOfInterest: 60,
    cityOfInterest: 60,
    universityName: 100,
    emailByWCC: 100,
    USI: 20,
    emergencyContactName: 60,
    emergencyContactRelationship: 40,
    emergencyContactNumber: 15,
    familyInfo: 100,
    biometricProcessCity: 60,
    agentReference: 50,
  };

  const clampValue = (value, maxLength) => {
    if (typeof value !== 'string') return value;
    if (!maxLength) return value;
    return value.slice(0, maxLength);
  };

  const sanitizeFieldValue = (field, value) => {
    if (typeof value !== 'string') return value;

    let sanitized = value;

    if (
      [
        'firstName',
        'lastName',
        'universityName',
        'city',
        'country',
        'countryOfInterest',
        'cityOfInterest',
        'emergencyContactName',
        'emergencyContactRelationship',
        'biometricProcessCity',
      ].includes(field)
    ) {
      sanitized = sanitized.replace(/[^a-zA-Z\s'-]/g, '');
    }

    if (
      [
        'zipcode',
        'children',
        'yearOfCompletion',
      ].includes(field)
    ) {
      sanitized = sanitized.replace(/\D/g, '');
    }
if(field==="jobTitle"){
      sanitized = sanitized.replace(/[^a-zA-Z\-\s,.()']/g, "")


}
if(field === "mobileNumber" || field === "emergencyContactNumber"){
      sanitized = sanitized.replace(/[^0-9+]/g, "")
      const plusCount = (sanitized.match(/\+/g) || []).length
      if (plusCount > 1) {
        sanitized = sanitized.replace(/\+/g, "")
      } else if (plusCount === 1) {
        sanitized = '+' + sanitized.replace(/\+/g, '')
      }
    }    if (field === 'passportNumber') {
      sanitized = sanitized.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    }

    if (field === "USI") {
      sanitized = sanitized.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    }

    if (field === "familyInfo") {
      sanitized = sanitized.replace(/[^a-zA-Z\-\s,()']/g, "")
    }

    return clampValue(sanitized, FIELD_LIMITS[field]);
  };

  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [cities, setCities] = useState([]);
  const [processTypes, setProcessTypes] = useState([]);
  const { isUpdating, updateError } = useSelector((state) => state.leads);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    passportNumber: '',
    passportExpiry: '',
    visaExpiryDate: '',
    dob: '',
    gender: '',
    age: '',
    visaCategory: '',
    maritalStatus: '',
    children: '',
    address: '',
    city: '',
    country: '',
    zipcode: '',
    mobileNumber: '',
    email: '',
    secondaryEmail: '',
    qualifications: '',
    yearOfCompletion: '',
    employmentType: '',
    jobTitle: '',
    countryOfInterest: '',
    cityOfInterest: '',
    universityName: '',
    emailByWCC: '',
    USI: '',
    emergencyContactName: '',
    emergencyContactRelationship: '',
    emergencyContactNumber: '',
    familyInfo: '',
    processType: '',
    biometricProcessDate: '',
    biometricProcessCity: '',
    agentReference: '',
    inquiryType: '',
    assignAgent: '',
    status: '',
    institution: '',
    institutionLocation: '',
  });

  // Initialize form data from selectedData
  useEffect(() => {
    if (selectedData) {
      setFormData({
        firstName: selectedData?.firstName || '',
        lastName: selectedData?.lastName || '',
        passportNumber: selectedData?.passportNumber || '',
        passportExpiry: selectedData?.passportExpiry
          ? moment(selectedData.passportExpiry).format('YYYY-MM-DD')
          : '',
        visaExpiryDate: selectedData?.visaExpiryDate
          ? moment(selectedData.visaExpiryDate).format('YYYY-MM-DD')
          : '',
        dob: selectedData?.dob
          ? moment(selectedData.dob).format('YYYY-MM-DD')
          : '',
        gender: selectedData?.gender || '',
        age: selectedData?.age || '',
        visaCategory: selectedData?.visaCategory || '',
        maritalStatus: selectedData?.maritalStatus || '',
        children: selectedData?.children || '',
        address: selectedData?.address || '',
        city: selectedData?.city || '',
        country: selectedData?.country || '',
        zipcode: selectedData?.zipcode || '',
        mobileNumber: selectedData?.mobileNumber || '',
        email: selectedData?.email || '',
        secondaryEmail: selectedData?.secondaryEmail || '',
        qualifications: selectedData?.qualifications || '',
        yearOfCompletion: selectedData?.yearOfCompletion || '',
        employmentType: selectedData?.employmentType || '',
        jobTitle: selectedData?.jobTitle || '',
        countryOfInterest: selectedData?.countryOfInterest || '',
        cityOfInterest: selectedData?.cityOfInterest || '',
        universityName: selectedData?.universityName || '',
        emailByWCC: selectedData?.emailByWCC || '',
        USI: selectedData?.USI || '',
        emergencyContactName: selectedData?.emergencyContactName || '',
        emergencyContactRelationship:
          selectedData?.emergencyContactRelationship || '',
        emergencyContactNumber: selectedData?.emergencyContactNumber || '',
        familyInfo: selectedData?.familyInfo || '',
        processType: selectedData?.processType || '',
        biometricProcessDate: selectedData?.biometricProcessDate
          ? moment(selectedData.biometricProcessDate).format('YYYY-MM-DD')
          : '',
        biometricProcessCity: selectedData?.biometricProcessCity || '',
        agentReference: selectedData?.agentReference || '',
        inquiryType: selectedData?.inquiryType || '',
        assignAgent: selectedData?.agent
          ? `${selectedData.agent.firstName} ${selectedData.agent.lastName}`
          : '',
        status: selectedData?.status || 'In-Process',
        institution: selectedData?.institution || '',
        institutionLocation: selectedData?.institutionLocation || '',
      });
    }
  }, [selectedData]);

  // Set edit mode to false by default
  useEffect(() => {
    setIsEditing(false);
  }, []);

  const statusOptions = [
    { label: 'Withdrawn', color: 'bg-red-500' },
    { label: 'In-Progress', color: 'bg-yellow-500' },
    { label: 'Submitted', color: 'bg-blue-500' },
    { label: 'Finalized', color: 'bg-green-500' },
  ];

  const [status, setStatus] = useState(selectedData?.status || 'In-Process');

  const handleInputChange = (e, field) => {
    const sanitizedValue = sanitizeFieldValue(field, e.target.value);

    setFormData({
      ...formData,
      [field]: sanitizedValue,
    });

    if (field === 'dob' && sanitizedValue) {
      const birthDate = new Date(sanitizedValue);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      setFormData((prevData) => ({
        ...prevData,
        age: age.toString(),
      }));
    }
  };

  const handleNumericKeyDown = (e) => {
    if (["e", "E", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleAlphabetKeyDown = (e) => {
    const allowedControlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Home',
      'End',
    ];

    if (allowedControlKeys.includes(e.key)) {
      return;
    }

    if (
      (e.ctrlKey || e.metaKey) &&
      ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())
    ) {
      return;
    }

    if (e.key === ' ') {
      return;
    }

    if (!/^[a-zA-Z]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleRelationKeyDown = (e) => {
    const allowedControlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Home',
      'End',
    ];

    if (allowedControlKeys.includes(e.key)) {
      return;
    }

    if (
      (e.ctrlKey || e.metaKey) &&
      ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())
    ) {
      return;
    }

    if (e.key === ' ' || e.key === '-' || e.key === "'") {
      return;
    }

    if (!/^[a-zA-Z]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const toggleEditMode = async () => {
    if (isEditing) {
      const normalizedFormData = Object.keys(formData).reduce((acc, key) => {
        acc[key] = sanitizeFieldValue(key, formData[key]);
        return acc;
      }, {});

      console.log('Saving form data:', normalizedFormData);
      try {
        setError(null); // Clear any previous errors
        const resultAction = await dispatch(
          updateApplication({ id: selectedData._id, formData: normalizedFormData }),
        );

        if (updateApplication.fulfilled.match(resultAction)) {
          setSuccess('Application updated successfully');
          setTimeout(() => {
            setSuccess(false);
          }, 5000);
        } else if (updateApplication.rejected.match(resultAction)) {
          // Handle rejected action
          const errorMessage =
            resultAction.error.message || 'Failed to update application';
          setError(errorMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
      } catch (error) {
        console.error('Error updating application:', error);
        setError(error.message || 'An unexpected error occurred');
        setTimeout(() => {
          setError(null);
        }, 5000);
      }
    }
    setIsEditing(!isEditing);
  };

  useEffect(() => {
    // const fetchCities = async () => {
    //   console.log(selectedData?.countryOfInterest);
    //   try {
    //     const response = await fetch(
    //       `${process.env.REACT_APP_API_BASE_URL}/api/user/getCities/${selectedData?.countryOfInterest}`,
    //     );
    //     if (!response.ok) {
    //       throw new Error('Failed to fetch cities');
    //     }
    //     const data = await response.json();
    //     console.log(data);
    //     setCities(data.body);
    //   } catch (error) {
    //     console.error('Error fetching cities:', error);
    //   }
    // };
    const fetchCities = async () => {
      try {
        let cities = getCitiesByCountry(selectedData?.countryOfInterest);
        setCities(cities);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    fetchCities();
  }, [selectedData?.countryOfInterest]);
  useEffect(() => {
    const fetchProcessTypes = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/processtype`,
          {
            headers: {
              Authorization: `bearer ${token}`,
            },
          },
        );
        if (!response.ok) {
          throw new Error('Failed to fetch cities');
        }
        const data = await response.json();
        setProcessTypes(data.body?.processTypes);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    fetchProcessTypes();
  }, []);
  return (
    <div className="p-3 md:p-6 rounded-lg shadow-sm bg-[#FFFBF5] border border-[#CAC3BB]">
      <div className="flex flex-col md:flex-row justify-between items-center mb-8">
        <h1
          onClick={() => console.log(selectedData)}
          className="text-2xl font-medium text-gray-900"
        >
          Application Details
        </h1>
        {/* <div className="relative">
          <div className="flex flex-col md:flex-row items-center">
            <span className="mr-4 text-gray-600 mb-2 md:mb-0">
              Application Status
            </span>
            <button
              onClick={() => setShowStatusDropdown(!showStatusDropdown)}
              className={`flex items-center gap-2 px-4 py-1 text-white rounded-full transition-all ${
                statusOptions.find((option) => option.label === status)
                  ?.color || "bg-gray-400"
              }`}
              disabled={!isEditing}
            >
              {status}
              <MdKeyboardArrowDown
                className={`transition-transform ${
                  showStatusDropdown ? "rotate-180" : ""
                }`}
              />
            </button>
          </div>
          {showStatusDropdown && isEditing && (
            <div className="absolute right-0 mt-2 w-max bg-slate-50 rounded-lg z-10 border shadow-custom p-0.5">
              {statusOptions.map((option, index) => (
                <div
                  key={index}
                  className={`text-white px-4 py-1 cursor-pointer mb-1 rounded-md ${
                    option.color
                  } hover:opacity-90 ${index === 0 ? "rounded-t-lg" : ""} ${
                    index === statusOptions.length - 1 ? "rounded-b-lg" : ""
                  }`}
                  onClick={() => {
                    setStatus(option.label);
                    setFormData({ ...formData, status: option.label });
                    setShowStatusDropdown(false);
                  }}
                >
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div> */}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
        {/* Left Column */}
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                First Name
              </label>
              <input
                type="text"
                value={formData.firstName}
                onChange={(e) => handleInputChange(e, 'firstName')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Last Name
              </label>
              <input
                type="text"
                value={formData.lastName}
                onChange={(e) => handleInputChange(e, 'lastName')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Passport Number
              </label>
              <input
                type="text"
                inputMode="text"
                pattern="[A-Z0-9]*"
                value={formData.passportNumber}
                onChange={(e) => handleInputChange(e, 'passportNumber')}
                
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Passport Expiry Date
              </label>
              <div className="mt-1 relative">
                <input
                  type="date"
                  value={formData.passportExpiry}
                  onChange={(e) => handleInputChange(e, 'passportExpiry')}
                  readOnly={!isEditing}
                  className={`w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
                />
                {/* <LuCalendar1 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 h-4 w-4" /> */}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Visa Expiry Date
              </label>
              <div className="mt-1 relative">
                <input
                  type="date"
                  value={formData.visaExpiryDate}
                  onChange={(e) => handleInputChange(e, 'visaExpiryDate')}
                  readOnly={!isEditing}
                  className={`w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
                />
                {/* <LuCalendar1 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 h-4 w-4" /> */}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Date of Birth
              </label>
              <div className="mt-1 relative">
                <input
                  type="date"
                  value={formData.dob}
                  onChange={(e) => handleInputChange(e, 'dob')}
                  readOnly={!isEditing}
                  className={`w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
                />
                {/* <LuCalendar1 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 h-4 w-4" /> */}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Gender
              </label>
              <select
                disabled={!isEditing}
                value={formData.gender}
                onChange={(e) => handleInputChange(e, 'gender')}
                className={`mt-1 w-full p-2 border rounded-md bg-white ${!isEditing ? 'opacity-70' : ''}`}
              >
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Not prefer to say">Not prefer to say</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Age
              </label>
              <input
                type="text"
                value={formData?.age || 0}
                readOnly={true}
                disabled
                className="mt-1 w-full p-2 border rounded-md bg-gray-100"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Marital Status
              </label>
              <select
                disabled={!isEditing}
                value={formData.maritalStatus}
                onChange={(e) => handleInputChange(e, 'maritalStatus')}
                className={`mt-1 w-full p-2 border rounded-md bg-white ${!isEditing ? 'opacity-70' : ''}`}
              >
                <option value="">Select</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="divorced">Divorced</option>
                <option value="widowed">Widowed</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Children
              </label>
              <input
                type="text"
                value={formData.children}
                onChange={(e) => handleInputChange(e, 'children')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Address
            </label>
            <input
              type="text"
              value={formData.address}
              onChange={(e) => handleInputChange(e, 'address')}
              readOnly={!isEditing}
              className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                City
              </label>
              <input
                type="text"
                value={formData.city}
                onChange={(e) => handleInputChange(e, 'city')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Country
              </label>
              <input
                type="text"
                value={formData.country}
                onChange={(e) => handleInputChange(e, 'country')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Zip Code
              </label>
              <input
                type="text"
                value={formData.zipcode}
                onChange={(e) => handleInputChange(e, 'zipcode')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Mobile No.
              </label>
              <input
                type="text"
                inputMode="tel"
                pattern="[0-9+]*"
                value={formData.mobileNumber}
                onChange={(e) => handleInputChange(e, 'mobileNumber')}
                onKeyDown={handleNumericKeyDown}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Primary Email Address
              </label>
              <input
                type="email"
                value={formData.secondaryEmail}
                onChange={(e) => handleInputChange(e, 'secondaryEmail')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Secondary Email Address
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleInputChange(e, 'email')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Qualification
            </label>
            <input
              type="text"
              value={formData.qualifications}
              onChange={(e) => handleInputChange(e, 'qualifications')}
              readOnly={!isEditing}
              className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Year of completion
            </label>
            <div className="mt-1 relative">
              <input
                type="text"
                value={formData.yearOfCompletion}
                onChange={(e) => handleInputChange(e, 'yearOfCompletion')}
                readOnly={!isEditing}
                className={`w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
              {/* <LuCalendar1 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 h-4 w-4" /> */}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Employment Type
              </label>
              <select
                disabled={!isEditing}
                value={formData.employmentType}
                onChange={(e) => handleInputChange(e, 'employmentType')}
                className={`mt-1 w-full p-2 border rounded-md bg-white ${!isEditing ? 'opacity-70' : ''}`}
              >
                <option value="">Select</option>
                <option value="Unemployed">Unemployed</option>
                <option value="Full-time">Full-time</option>
                <option value="Part-time">Part-time</option>
                <option value="Contract">Contract</option>
                <option value="Internship">Internship</option>
                <option value="Freelance">Freelance</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Job Title
              </label>
              <input
                type="text"
                value={formData.jobTitle}
                onChange={(e) => handleInputChange(e, 'jobTitle')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Country of Interest
              </label>
              <input
                type="text"
                value={formData.countryOfInterest}
                onChange={(e) => handleInputChange(e, 'countryOfInterest')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
            <div>
              <label
                onClick={() => console.log(cities)}
                className="block font-medium text-gray-700"
              >
                Destination City
              </label>
              <CustomSelect
                options={cities}
                value={formData.cityOfInterest}
                onChange={(val) =>
                  setFormData({ ...formData, cityOfInterest: val })
                }
                placeholder="Select"
                disabled={!isEditing}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              University Name
            </label>
            <input
              type="text"
              value={formData.universityName}
              onChange={(e) => handleInputChange(e, 'universityName')}
              readOnly={!isEditing}
              className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email by WCC
            </label>
            <input
              type="email"
              value={formData.emailByWCC}
              onChange={(e) => handleInputChange(e, 'emailByWCC')}
              readOnly={!isEditing}
              className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Unique Student Identifier(USI)
            </label>
            <input
              type="text"
              inputMode="text"
                pattern="[A-Z0-9]*"
 
              maxLength={FIELD_LIMITS.USI}
              value={formData.USI}
              onChange={(e) => handleInputChange(e, 'USI')}

              readOnly={!isEditing}
              className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
            />
          </div>

          
          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Emergency Contact Name</label>
              <input
                type="text"
                placeholder="Name"
                value={formData.emergencyContactName}
                onChange={(e) => handleInputChange(e, 'emergencyContactName')}
                readOnly={!isEditing}
                className={`w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
            <div className="space-y-2">
              <label className="block font-medium text-gray-700">Relation</label>
              <input
                type="text"
                placeholder="Relation"
                value={formData.emergencyContactRelationship}
                onChange={(e) =>
                  handleInputChange(e, 'emergencyContactRelationship')
                }
                onKeyDown={handleRelationKeyDown}
                readOnly={!isEditing}
                className={`w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Emergency Contact Number
            </label>
            <input
              type="text"
             inputMode="tel"
              pattern="[0-9+]*"
              value={formData.emergencyContactNumber}
              onChange={(e) => handleInputChange(e, 'emergencyContactNumber')}
              onKeyDown={handleNumericKeyDown}
              readOnly={!isEditing}
              className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Pending Info:
            </label>
                <textarea
              value={formData.familyInfo}
                onChange={(e) => handleInputChange(e, 'familyInfo')}
                readOnly={!isEditing}
                className={`mt-1 w-full p-2 border rounded-md min-h-[120px] resize-y ${isEditing ? 'bg-white' : ''}`}
              />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Process Type
            </label>
            <select
              disabled={!isEditing}
              value={formData.processType?._id?.toString() || formData.processType?.toString() || ''}
              onChange={(e) => handleInputChange(e, 'processType')}
              className={`mt-1 w-full p-2 border rounded-md bg-white ${!isEditing ? 'opacity-70' : ''}`}
            >
              <option value="">Select</option>
              {processTypes?.map((eachProcessType) => {
                return (
                  <option
                    key={eachProcessType?._id}
                    value={eachProcessType?._id.toString()}
                  >
                    {eachProcessType?.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div>
            <div className="mb-2">Biometric Appointment</div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Date
                </label>
                <div className="mt-1 relative">
                  <input
                    type="date"
                    value={formData.biometricProcessDate}
                    onChange={(e) =>
                      handleInputChange(e, 'biometricProcessDate')
                    }
                    readOnly={!isEditing}
                    className={`w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
                  />
                  {/* <LuCalendar1 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 h-4 w-4" /> */}
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  City
                </label>
                <input
                  type="text"
                  value={formData.biometricProcessCity}
                  onChange={(e) => handleInputChange(e, 'biometricProcessCity')}
                  readOnly={!isEditing}
                  className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
                />
              </div>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Agent Reference
            </label>
            <input
              type="text"
              value={formData.agentReference}
              onChange={(e) => handleInputChange(e, 'agentReference')}
              readOnly={!isEditing}
              className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Assign Agent(auto filled field by agent)
            </label>
            <input
              type="text"
              value={formData.assignAgent}
              onChange={(e) => handleInputChange(e, 'assignAgent')}
              readOnly
              className={`mt-1 w-full p-2 border rounded-md ${isEditing ? 'bg-white' : ''}`}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Inquiry Type
            </label>
            <select
              disabled={!isEditing}
              value={formData.inquiryType}
              onChange={(e) => handleInputChange(e, 'inquiryType')}
              className={`mt-1 w-full p-2 border rounded-md bg-white ${!isEditing ? 'opacity-70' : ''}`}
            >
              <option value="">Select</option>
              <option value="Walk-In">Walk-In</option>
              <option value="Call">Call</option>
              <option value="Social">Social</option>
            </select>
          </div>
          {formData.visaCategory === 'Study Visa' && (
            <>
              {/* <div className="space-y-2">
                <label className="block font-medium text-gray-700">Institute Name</label>
                <input
                  type="text"
                  readOnly={!isEditing}
                  placeholder="Enter institution name"
                  value={formData.institution}
                  onChange={(e) => handleInputChange(e, "institution")}
                  className={`w-full p-2 border rounded-md text-gray-700 ${isEditing ? "bg-white" : ""}`}
                />
              </div>

              <div className="space-y-2">
                <label className="block font-medium text-gray-700">Institute Location</label>
                <input
                  type="text"
                  readOnly={!isEditing}
                  placeholder="Enter institution location"
                  value={formData.institutionLocation}
                  onChange={(e) => handleInputChange(e, "institutionLocation")}
                  className={`w-full p-2 border rounded-md text-gray-700 ${isEditing ? "bg-white" : ""}`}
                />
              </div> */}
              {/* <div className="space-y-2">
                <label className="block font-medium text-gray-700">Offer Letter Status</label>
                <input
                  type="text"
                  readOnly={!isEditing}
                  placeholder="Enter offer letter status"
                  value={formData.offerLetterStatus || ""}
                  onChange={(e) => handleInputChange(e, "offerLetterStatus")}
                  className={`w-full p-2 border rounded-md text-gray-700 ${isEditing ? "bg-white" : ""}`}
                />
              </div>

              <div className="space-y-2">
                <label className="block font-medium text-gray-700">Offer Letter Uploaded</label>
                <input
                  type="text"
                  readOnly={!isEditing}
                  placeholder="Yes/No"
                  value={formData.offerLetterUploaded || ""}
                  onChange={(e) => handleInputChange(e, "offerLetterUploaded")}
                  className={`w-full p-2 border rounded-md text-gray-700 ${isEditing ? "bg-white" : ""}`}
                />
              </div> */}
            </>
          )}
        </div>
      </div>
      {success && (
        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5 }}
          className="text-green-500 text-right"
        >
          {success}
        </motion.p>
      )}
      {error && (
        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5 }}
          className="text-red-500 text-right text-sm"
        >
          {error}
        </motion.p>
      )}
      {/* {updateError&& (
        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5 }}
          className="text-red-500 text-right text-sm"
        >
          {updateError}
        </motion.p>
      )} */}
      <div className="flex justify-end gap-4 mt-8">
        {isEditing && (
          <>
            {' '}
            {isUpdating ? (
              <button className="w-[176.26px] h-[40px] bg-[#005787] rounded-full flex items-center justify-center">
                <span className="loader"></span>
              </button>
            ) : (
              <button
                onClick={toggleEditMode}
                className="px-8 py-2 bg-[#005787] text-white rounded-full hover:bg-[#004a70] transition-colors"
              >
                Save Progress
              </button>
            )}{' '}
          </>
        )}

        {!isEditing && (
          <>
            {isUpdating ? (
              <button className="w-[176.26px] h-[40px] bg-[#005787] rounded-full flex items-center justify-center">
                <span className="loader"></span>
              </button>
            ) : user?.role === 'admin' || user?.role === 'sub-admin' ||
              (user?.role === 'agent' &&
                user?._id === selectedData?.agent?._id) ? (
              <button
                onClick={toggleEditMode}
                className="px-8 py-2 bg-[#005787] text-white rounded-full hover:bg-[#004a70] transition-colors"
              >
                Edit
              </button>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}
